import { getContactRepresentation } from '../../../utils/functions'
import { RichContact, SelectOption } from '../../../utils/types'
import { Customer } from '../../Customer/utils/types'
import { Supplier } from '../../Supplier/utils/types'

export interface RichContactGroupingResult {
  store: Record<string, RichContact[]>
  options: SelectOption[]
}

/**
 * Group rich contacts by related supplier/customer and build select options.
 */
export function buildRichContactGrouping(richContacts: RichContact[]): RichContactGroupingResult {
  const store: Record<string, RichContact[]> = {}

  richContacts.forEach((contact: RichContact) => {
    contact.suppliers.forEach((supplier: Supplier) => {
      if (!supplier?.name) return
      store[supplier.name] = store[supplier.name] ? [...store[supplier.name], contact] : [contact]
    })

    contact.customers.forEach((customer: Customer) => {
      if (!customer?.name) return
      store[customer.name] = store[customer.name] ? [...store[customer.name], contact] : [contact]
    })

    if (contact.suppliers.length === 0 && contact.customers.length === 0) {
      store.unrelated = store.unrelated ? [...store.unrelated, contact] : [contact]
    }
  })

  const options: SelectOption[] = []
  Object.keys(store).forEach(relatedToName => {
    store[relatedToName].forEach(contact => {
      options.push({
        value: contact.self,
        label: getContactRepresentation(
          contact,
          relatedToName !== 'unrelated' ? relatedToName : undefined
        ),
      })
    })
  })

  return { store, options }
}
